import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCustomerSettingsService } from './customer-settings.service';
import { FiCustomerSettingsComponent } from './customer-settings.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { MatCardModule } from '@angular/material/card';
import { FiCustomerSettingsEditImageComponent } from './edit-image/edit-image.component';
import { FormsModule } from '@angular/forms';
import { FiCustomerSettingsPreviewDialogComponent } from './customer-settings-preview-dialog/customer-settings-preview-dialog.component';
import { FiAuthenticateModule } from '@fi-app/authenticate/authenticate.module';
import { FiCustomerSettingsPreviewMobileAppComponent } from './customer-settings-preview-mobile-app/customer-settings-preview-mobile-app.component';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';

@NgModule({
    imports: [CommonModule, UtilitiesModule, MatCardModule, FormsModule, FiAuthenticateModule, FiPageHeaderModule],
    declarations: [
        FiCustomerSettingsComponent,
        FiCustomerSettingsEditImageComponent,
        FiCustomerSettingsPreviewDialogComponent,
        FiCustomerSettingsPreviewMobileAppComponent,
    ],
    exports: [FiCustomerSettingsComponent],
    providers: [FiCustomerSettingsService],
})
export class FiCustomerSettingsModule {}
